<template>
  <div class="billing-payment-terms__wrap">
    <div v-if="enableInrRecurringChargesTable" class="billing-payment-terms__charge-process">
      <p>{{ __$t('billing.terms.emandate_charge_process_table.table_desc') }}</p>
      <zm-table :data="chargeProcessData" border class="billing-payment-terms__charge-process-table">
        <zm-table-column
          prop="amount"
          :label="__$t('billing.terms.emandate_charge_process_table.threshold_header')"
          width="153"
        ></zm-table-column>
        <zm-table-column prop="action" :label="__$t('billing.terms.emandate_charge_process_table.action_header')">
          <template slot-scope="scope">
            <span slot="content" v-html="scope.row.action" />
          </template>
        </zm-table-column>
      </zm-table>
    </div>
    <div class="billing-payment-terms__charge-desc" v-html="paymentMethodDisclaimersText"></div>
    <div
      v-if="isInrCurrency"
      class="billing-payment-terms__charge-desc"
      v-html="__$t('billing.terms.pay_method_tokenization_disclaimer')"
    ></div>
  </div>
</template>

<script>
import moment from 'moment'
import { dateTimeFormat } from '../../utils/dateformat'
import { isInrCurrency } from '../../utils/currency'
import { translateMixins } from '../../plugins/i18n'
import { mapGetters } from 'vuex'
import { APP_NAMESPACE } from '../../store'

export default {
  name: 'terms',
  props: {
    indiaMandateAmountFormatted: String,
    enableInrRecurringChargesTable: Boolean
  },
  mixins: [translateMixins],
  computed: {
    ...mapGetters(APP_NAMESPACE, ['isSepaEligible']),
    isInrCurrency() {
      return isInrCurrency()
    },
    paymentMethodDisclaimersText() {
      if (this.isInrCurrency) {
        const startDate = moment()
        const endDate = moment().add(20, 'year')
        return this.__$t('billing.terms.india_emandate_desc', [
          dateTimeFormat(startDate),
          dateTimeFormat(endDate),
          this.indiaMandateAmountFormatted
        ])
      }
      if (this.isSepaEligible) {
        return this.__$t('billing.terms.sepa_payment_terms')
      }
      return ''
    },
    chargeProcessData() {
      return [
        {
          amount: this.__$t('billing.terms.emandate_charge_process_table.threshold_1', [
            this.indiaMandateAmountFormatted
          ]),
          action: this.__$t('billing.terms.emandate_charge_process_table.action_1')
        },
        {
          amount: this.__$t('billing.terms.emandate_charge_process_table.threshold_2', [
            this.indiaMandateAmountFormatted
          ]),
          action: this.__$t('billing.terms.emandate_charge_process_table.action_2')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.billing-payment-terms {
  &__wrap {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #131619;
    margin-top: 24px;
  }

  &__charge-desc {
    font-weight: 500;

    a {
      color: $focus-color;
    }
  }

  &__charge-desc,
  &__charge-desc p {
    margin-bottom: 16px;
  }

  &__charge-process {
    margin-bottom: 30px;
    p {
      margin-bottom: 15px;
    }
  }

  &__charge-process-table {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #131619;
    width: 100%;
    ::v-deep th {
      color: #131619;
      background-color: #f1f4f6;
    }
    ::v-deep a {
      color: $focus-color;
    }
  }
}
</style>
